export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";